import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                91视频网
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              海量高清视频在线观看平台，汇聚娱乐、教程、生活、音乐、体育等多元内容，为您提供流畅的在线视频观看体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-background-50 text-base font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">使用条款</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">隐私政策</a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-background-50 text-base font-semibold mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-background-50 text-base font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-background-500"></i>
                <span>contact@91video.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line mt-0.5 text-background-500"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-background-500"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 91视频网 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <p className="text-xs text-background-600">
            专注高清视频 · 畅享极致体验
          </p>
        </div>
      </div>
    </footer>
  );
}